import React from "react";
import "../../App.css"; // Import global CSS for any global styling
import { FaSpinner } from "react-icons/fa"; // Import a spinner icon from react-icons

const loadingPageStyle = {
  container: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    overflow: "hidden",
    fontFamily: "'Poppins', sans-serif",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backdropFilter: "blur(3px)", // Optional: adds a subtle blur effect to the background
  },
  loaderContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    textAlign: "center",
    background: "rgba(255, 255, 255, 0.3)", // Semi-transparent background for the loader
    padding: "20px 40px",
    borderRadius: "15px",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
    maxWidth: "320px",
    width: "70%",
    maxWidth: '200px',
    border: "2px solid #f1f8e9",
  },
  spinner: {
    fontSize: "50px", // Adjust the size of the spinner
    color: "#66bb6a", // Use the same green color as the theme
    animation: "spin 2s infinite linear", // Infinite spinning animation
  },
  message: {
    fontSize: "1.2rem",
    color: "#fff",
    marginTop: "20px",
    fontFamily: "'Roboto Slab', serif",
    fontWeight: "bold",
    textShadow: "1px 1px 3px rgba(0, 0, 0, 0.4)", // Text shadow for visibility
  },
};

// Add keyframes animation for spinning
const spinKeyframes = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const LoadingPage = () => {
  return (
    <>
      {/* Inject the keyframes into the document */}
      <style>{spinKeyframes}</style>
      
      <div style={loadingPageStyle.container}>
        <div style={loadingPageStyle.loaderContainer}>
          <FaSpinner style={loadingPageStyle.spinner} />
          <div style={loadingPageStyle.message}>Loading, please wait...</div>
        </div>
      </div>
    </>
  );
};

export default LoadingPage;
